import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiAnalyticsPlansKnowledgeInsightPostsIndexResponseType,
  ApiAnalyticsPlansKnowledgeInsightPostsIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiAnalyticsPlansKnowledgeInsightPostsIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiAnalyticsPlansKnowledgeInsightPostsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiAnalyticsPlansKnowledgeInsightPostsIndexResponseType>(
      "/api/analytics_plans/knowledge_insight_posts",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiAnalyticsPlansKnowledgeInsightPostsIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAnalyticsPlansKnowledgeInsightPostsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseQueryResult<ApiAnalyticsPlansKnowledgeInsightPostsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisAnalyticsPlansKnowledgeInsightPostsIndex", params],
    queryFn: () => request({ params }),
  });
};
